// extracted by css-extract-rspack-plugin
export default {"navigator":"Navigator__navigator--jtnHJ","header":"Navigator__header--jyE2l","body":"Navigator__body--czmVh","item":"Navigator__item--fpNNQ"};